import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { connect } from 'react-redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getDecisionFormRef } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import { KnmAttachmentsSigning } from '../../../KnmPackage/MainModule/components/KnmAttachmentsSigning';

interface IDecisionResultDocumentWithoutStore {
  formRef: IDecisionFormRef | undefined;
}
interface IDecisionResultDocumentProps {
  resultDecisionIndex: number;
  watchOnly: boolean;
  attachmentsNumber: number;
  name: string;
}

const DecisionResultDocumentWithoutStore = memo(
  ({
    watchOnly,
    attachmentsNumber,
    formRef,
    name,
    resultDecisionIndex,
  }: IDecisionResultDocumentProps & IDecisionResultDocumentWithoutStore) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <>
        <div className="shared-group-label">
          Документ&nbsp;
          <span className="shared-no-wrap-text">
            решения
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          isWatchOnly={watchOnly}
          name={`${name}.attachments`}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError = props.errors?.organization?.resultDecisions[resultDecisionIndex]?.document;
            const isFieldTouched =
              props.touched?.[`organization.resultDecisions[${attachmentsNumber}].document.attachments`];

            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (isFieldTouched && errorMessage) {
              return <p className="shared-input-error shared-row__small-margin">{errorMessage}</p>;
            }

            return null;
          }}
        </FormSpy>
      </>
    );
  },
);

const mapStateToProps = (state: IRootState): IDecisionResultDocumentWithoutStore => ({
  formRef: getDecisionFormRef(state),
});

export const DecisionResultDocument = connect(mapStateToProps)(DecisionResultDocumentWithoutStore);
